import { useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { ResetBtn, UseBtn } from 'libs/ui';
import { CategoryFilter, ClassFilter, Container, Input, ParkingFilter, DictFilter, ButtonsContainer, DoubleField, DateSelect, DateTime } from 'libs/form';

const initial = {};

const Filter = (props) => {
  const { setInitial, reset, handleSubmit, theme, change, clientId } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initial);
    return () => {
      reset();
      setInitial(initial);
    };
  }, []);

  return (
    <Container theme={theme}>
      <form onSubmit={handleSubmit}>
        <DictFilter w={140} dict="rfid.status" exclude={!clientId ? [] : ['blocked_by_client']} />

        <Input width="170px" name="rfid" type="text" label={t('sections.RFID')} placeholder="3786 4678 6467 5656" />

        {!clientId && <Input width="220px" name="client_name" type="text" label={t('form.Клиент')} placeholder={t('form.Иванов И.И.')} />}

        <Input width="220px" name="owner_name" type="text" label={t('form.Держатель')} placeholder={t('form.Иванов И.И.')} />

        <DateSelect from_name="start_at_from" to_name="start_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="start_at_from" type="dateTime" label={t('form.Дата действия с')} theme={theme} />
            <DateTime width="160px" name="start_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <DateSelect from_name="end_at_from" to_name="end_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="end_at_from" type="dateTime" label={t('form.Дата действия по')} theme={theme} />
            <DateTime width="160px" name="end_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <CategoryFilter multiple />

        {!clientId && <ClassFilter multiple />}

        <Input width={'230px'} name="tariff" type="text" label={t('form.Тариф')} placeholder={t('filter.Базовый')} />

        <Input width="170px" name="vehicle_plate" type="text" label={t('sections.ГРЗ')} placeholder={t('form.А000AA 000 rus')} />

        <Input width={'230px'} label={t('filter.Комментарий')} name="comment" type="text" placeholder={t('filter.Текст комментария')} lastField />

        <ParkingFilter />

        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'rfidFilter',
  destroyOnUnmount: false,
  initialValues: initial,
})(Filter);
